import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { crmApi } from '@/api';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

/** Handles Google OAuth redirect for CRM XOAUTH2 IMAP (no app password). */
export function CrmGoogleOAuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = params.get('code');
    const error = params.get('error');
    if (error) {
      notify.error(`Google OAuth failed: ${error}`);
      navigate('/crm/setup', { replace: true });
      return;
    }
    if (!code) return;

    crmApi
      .connectGoogleOAuth(code)
      .then((account) => {
        notify.success(`Gmail connected via XOAUTH2: ${account.emailAddress}`);
        navigate('/crm/setup', { replace: true });
      })
      .catch((e) => {
        showApiError(e, 'OAuth connect failed');
        navigate('/crm/setup', { replace: true });
      });
  }, [params, navigate]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center text-slate-600">
      Connecting Gmail account…
    </div>
  );
}
